import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { Tree, Classes } from "./externals";
function forNodeAtPath(nodes, path, callback) {
    callback(Tree.nodeFromPath(path, nodes));
}
export const CustomTree = ({ initialState, selectedNode, onNodeSelect, }) => {
    const [nodes, setNodes] = useState(initialState);
    useEffect(() => {
        setNodes(initialState);
    }, [initialState]);
    const getParentNode = useCallback((childPath) => {
        const parentPath = [childPath[0]];
        return Tree.nodeFromPath(parentPath, nodes);
    }, [initialState]);
    const handleNodeClick = useCallback((selectedNode, nodePath) => {
        setNodes((previousState) => {
            const newState = _.cloneDeep(previousState);
            forNodeAtPath(newState, nodePath, (node) => {
                if (!("childNodes" in node)) {
                    if (selectedNode && nodePath !== selectedNode.path) {
                        forNodeAtPath(newState, selectedNode.path, (node) => (node.isSelected = false));
                    }
                    node.isSelected = !node.isSelected;
                    const parentNode = getParentNode(nodePath);
                    onNodeSelect({
                        path: nodePath,
                        data: node,
                        parentData: parentNode,
                    });
                }
                else {
                    node.isExpanded = !node.isExpanded;
                }
            });
            return newState;
        });
    }, [initialState]);
    const handleNodeCollapseOrExpand = useCallback((_node, nodePath) => {
        setNodes((previousState) => {
            const newState = _.cloneDeep(previousState);
            forNodeAtPath(newState, nodePath, (node) => (node.isExpanded = !node.isExpanded));
            return newState;
        });
    }, [initialState]);
    return (React.createElement(Tree, { contents: nodes, onNodeClick: (_nodeClicked, nodePath) => handleNodeClick(selectedNode, nodePath), onNodeCollapse: handleNodeCollapseOrExpand, onNodeExpand: handleNodeCollapseOrExpand, className: Classes.ELEVATION_0 }));
};
//# sourceMappingURL=CustomTree.js.map